export default "__VITE_ASSET__B3WA8H5d__"